let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("aSCoB")).then(() => parcelRequire('4Mccv'));